export default "/assets/website/images/delivery_icon.svg?854dc4a267858078d8ed0d35e8465f43";